import React from 'react';
import { gql } from '@apollo/client';
import { Link } from '../utils/router/v3Bridge';
import userPath from '../utils/url/userPath';
import type { PresenceAvatarStatus } from './PresenceAvatar';
import PresenceAvatar from './PresenceAvatar';
import styles from './PresenceAvatarStack.module.scss';
import type { PresenceAvatarStack_UserFragment } from '../graphql/generated/graphqlTypes';

const PRESENCE_AVATAR_STAC_USER_FRAGMENT = gql`
  fragment PresenceAvatarStack_user on User {
    id
    ...PresenceAvatar_user
  }
  ${PresenceAvatar.fragments.user}
`;

interface PresenceAvatarStackProps {
  users: {
    user: PresenceAvatarStack_UserFragment & { index: number };
    status: PresenceAvatarStatus;
  }[];
}

const PresenceAvatarStack = ({ users }: PresenceAvatarStackProps) => (
  <div className={styles.container}>
    {users.map(({ user, status }) => (
      <div key={user.id} className={styles.avatar}>
        <Link key={user.id} to={userPath(user)}>
          <PresenceAvatar status={status} index={user.index} user={user} />
        </Link>
      </div>
    ))}
  </div>
);

PresenceAvatarStack.fragments = {
  user: PRESENCE_AVATAR_STAC_USER_FRAGMENT,
};

export default PresenceAvatarStack;
